<template>
  <div class="exam-page">
    <el-card class="exam-card">
      <h2 class="exam-title">考试页面</h2>
      <!-- 显示当前题目 -->
      <el-form ref="examForm" :model="answers" label-width="100px" class="exam-form">
        <el-form-item :label="`第${currentQuestionIndex + 1}题`" class="question-item">
          <el-card class="question-card">
            <p class="question-text"><strong>{{ currentQuestion.question }}</strong></p>

            <!-- 根据题目类型展示不同的输入框 -->
            <template v-if="currentQuestion.type === '填空题'">
              <el-input
                v-model="answers[currentQuestion.id]"
                placeholder="请输入答案"
                :rows="2"
                autosize
                class="answer-input"
                ref="answerInput"
              ></el-input>
            </template>

            <template v-if="currentQuestion.type === '选择题'">
              <el-radio-group v-model="answers[currentQuestion.id]" class="answer-options">
                <!-- 动态生成选择项 -->
                <el-radio
                  v-for="(option, index) in currentQuestion.options"
                  :key="index"
                  :label="option"
                  class="radio-option"
                >
                  {{ option }}
                </el-radio>
              </el-radio-group>
            </template>

            <p class="question-score"><strong>分数：{{ currentQuestion.score }}</strong></p>
          </el-card>
        </el-form-item>

        <!-- 上一题和下一题按钮 -->
        <div class="navigation-buttons">
          <el-button
            :disabled="currentQuestionIndex === 0"
            @click="prevQuestion"
            type="primary"
            class="nav-btn"
          >
            上一题
          </el-button>
          <el-button
            :disabled="currentQuestionIndex === questions.length - 1"
            @click="nextQuestion"
            type="primary"
            class="nav-btn"
          >
            下一题
          </el-button>
        </div>

        <!-- 提交考试按钮 -->
        <div class="submit-section">
          <el-button @click="submitExam" type="success" class="submit-btn">
            提交考试
          </el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import axios from '@/axios'

export default {
  // props: {
  //   userid: {
  //     type: Number,  // 假设用户ID是字符串
  //     required: true
  //   },
  //   organizationID: {
  //     type: Number,  // 假设机构ID是字符串
  //     required: true
  //   }
  // },
  data() {
    return {
      questions: [
        // 示例题目
        {
          id: 3,
          question: "What is 2 + 2?",
          answer: "4",
          score: 2,
          type: "填空题",
        },
        {
          id: 4,
          question: "Who wrote 'To Kill a Mockingbird'?",
          answer: "Harper Lee",
          score: 10,
          type: "填空题",
        },
        {
          id: 12,
          question: "1+122为多少",
          answer: "A:123,B:123441,C:1233", // 选项字段
          score: 2,
          type: "选择题",
        },
      ],
      currentQuestionIndex: 0,
      answers: {},  // 用户的答案
    };
  },
  computed: {
    currentQuestion() {
      return this.questions[this.currentQuestionIndex];
    }
  },
  methods: {
    prevQuestion() {
      if (this.currentQuestionIndex > 0) {
        this.currentQuestionIndex -= 1;
      }
    },
    nextQuestion() {
      if (this.currentQuestionIndex < this.questions.length - 1) {
        this.currentQuestionIndex += 1;
      }
      if (this.currentQuestion.type === '填空题') {
        this.$nextTick(() => {
          this.$refs.answerInput.focus();
        });
      }
    },
    // 提交考试
    submitExam() {
      const submittedAnswers = {};

      // 判断是否答完所有题目
      for (let question of this.questions) {
        const userAnswer = this.answers[question.id];
        if (!userAnswer) {
          // 如果有未答的题目，提醒用户
          this.$message.error(`请回答第 ${this.questions.indexOf(question) + 1} 题`);
          return;
        }
        // 将答案保存到提交的数据中
        submittedAnswers[question.id] = userAnswer;
      }
console.log(submittedAnswers)
    let  userid=this.$route.query.userid
    let  organizationID=this.$route.query.organizationID
      let examid=this.$route.query.examid
      // 如果都答完，提交答案
      axios
        .post("/Exam/submit", {submittedAnswers,userid,examid})
        .then((response) => {
          if(response.data.success) {
            this.$message.success(response.data.data);
            this.$router.push({path: '/z', query: { userid:userid,organizationID
                    : organizationID}})
// 跳转到 "/home?userid=123"

          }
          else {
            this.$message.error(response.data.errorMsg);
          }
        })
        .catch((error) => {
          console.error("提交失败:", error);
          this.$message.error("提交失败，请重试");
        });
    },
    // 解析answer字段中的选项
    parseOptions(answer) {
      if (!answer) return [];
      return answer.split(',').map(option => option.trim());
    }
  },
  created() {
    // 模拟从路由获取考试数据
    console.log(this.$route.query.questions);
    this.questions = JSON.parse(this.$route.query.questions);
    console.log('接收到的参数：', this.questions);

    // 为每个选择题解析选项
    this.questions.forEach(question => {
      if (question.type === '选择题') {
        question.options = this.parseOptions(question.options); // 将answer中的选项分隔并存储在options字段中
      }
    });
  },
};
</script>

<style scoped>
.exam-page {
  padding: 20px;
  background-color: #f4f6f9;
  display: flex;
  justify-content: center;
}

.exam-card {
  width: 80%;
  max-width: 900px;
  padding: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background-color: white;
}

.exam-title {
  font-size: 24px;
  color: #409EFF;
  text-align: center;
  margin-bottom: 20px;
}

.exam-form {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.question-item {
  margin-bottom: 20px;
  width: 100%;
}

.question-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.05);
}

.question-text {
  font-size: 18px;
  margin-bottom: 15px;
  text-align: center;
}

.answer-input {
  width: 100%;
  max-width: 500px;
  margin-top: 15px;
}

.answer-options {
  display: flex;
  flex-direction: column;
  align-items: flex-start;  /* 左对齐 */
  width: 100%;
  max-width: 500px;
  margin-top: 10px;
}

.radio-option {
  white-space: normal; /* 使选项内容超过容器宽度时换行 */
  word-break: break-word; /* 防止长单词导致内容超出容器 */
}

.question-score {
  margin-top: 15px;
  font-size: 16px;
  color: #606266;
}

.navigation-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.nav-btn {
  margin: 0 10px;
}

.submit-section {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.submit-btn {
  width: 200px;
}
</style>
